import * as R from "ramda";

export const isAdmin = R.pipe(
  R.propOr([], "roles"),
  R.filter(R.includes(R.__, ["admin", "headadmin"])),
  R.isEmpty,
  R.not
);

export const canCreateOpportunity = user =>
  isAdmin(user) || R.pathOr(true, ["config", "createOpportunity"], user);
